import { ftAccessToken, ftRefreshToken } from "../constants/Constants";
import { refreshToken } from "./AuthService";
import { properties } from "../properties";

function authedRequest(method, path, firstCall, retryFn) {
    return new Promise((resolve, reject) => {
        const accessToken = localStorage.getItem(ftAccessToken)?.replaceAll('"', '');
        const xhttp = new XMLHttpRequest();
        xhttp.open(method, properties.host + path, true);
        xhttp.setRequestHeader("Authorization", "Bearer " + accessToken);
        xhttp.onreadystatechange = function () {
            if (this.readyState !== 4) return;
            if (this.status >= 200 && this.status < 300) {
                resolve(this.responseText ? JSON.parse(this.responseText) : {});
            } else if ((this.status === 401 || this.status === 403) && firstCall) {
                refreshToken().then(newAccessToken => {
                    localStorage.setItem(ftAccessToken, JSON.stringify(newAccessToken));
                    retryFn().then(resolve).catch(reject);
                }).catch(() => {
                    localStorage.removeItem(ftAccessToken);
                    localStorage.removeItem(ftRefreshToken);
                    reject({ error: new Error("Failed to refresh token."), status: this.status });
                });
            } else {
                reject(new Error(`Request failed: ${this.status}`));
            }
        };
        xhttp.send();
    });
}

export function fetchNotifications(limit = 30, firstCall = true) {
    return authedRequest("GET", `/notifications?limit=${limit}`, firstCall, () => fetchNotifications(limit, false));
}

export function fetchUnreadCount(firstCall = true) {
    return authedRequest("GET", "/notifications/unread-count", firstCall, () => fetchUnreadCount(false));
}

export function markNotificationRead(id, firstCall = true) {
    return authedRequest("POST", `/notifications/${id}/read`, firstCall, () => markNotificationRead(id, false));
}

export function markAllNotificationsRead(firstCall = true) {
    return authedRequest("POST", "/notifications/read-all", firstCall, () => markAllNotificationsRead(false));
}

export function dismissNotification(id, firstCall = true) {
    return authedRequest("DELETE", `/notifications/${id}`, firstCall, () => dismissNotification(id, false));
}
